"use client";
import { jsx as o } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { FileInput as m } from "../../atoms/FileInput/FileInput.mjs";
const s = i(
  ({ children: r, state: e = "default", useButtonWrapper: t = !0, ...p }, u) => /* @__PURE__ */ o(
    m,
    {
      ref: u,
      state: e,
      useButtonWrapper: t && e !== "success",
      accept: "image/*",
      ...p,
      children: r
    }
  )
);
s.displayName = "ImageFileInput";
export {
  s as ImageFileInput
};
